/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import LandingPageLayout from '../components/layouts/LandingPageLayout';
import TeamPhoto from '../assets/images/LandingPage/teamphoto.png';
import Image from 'next/image';
export const meta = {
  author: 'Eirik Berre'
};
const MDXLayout = ({children}) => _jsx(LandingPageLayout, {
  mdx: true,
  meta: meta,
  title: "The world wide Curipod community",
  subTitle: "Join our community to learn about Curipod from fellow educators and the Curipod team.\n\n",
  image: TeamPhoto,
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      h3: "h3",
      ul: "ul",
      li: "li"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsxs(_components.p, {
        children: ["Join our community on Facebook ", _jsx("a", {
          href: "https://www.facebook.com/groups/629277211454616",
          target: "__blank",
          children: "here"
        }), "."]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h3, {
        children: "The community is a great place to:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Learn from fellow educators"
        }), "\n", _jsx(_components.li, {
          children: "Share ideas with fellow educators"
        }), "\n", _jsx(_components.li, {
          children: "Share your feedback and ideas with the Curipod team"
        }), "\n", _jsx(_components.li, {
          children: "See everything we work on and what comes next in Curipod"
        }), "\n"]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {})]
    });
  }
}
export default MDXContent;
